import { StyleSheet } from '@react-pdf/renderer';

export const Styles = StyleSheet.create({
  container: {
    margin: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  containerClient: {
    borderWidth: 2,
    borderRadius: 6,
    padding: 10,
    marginTop: 10,
  },
  containerTreatmentView: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 10,
    marginTop: 3,
  },
  label: {
    fontWeight: 'bold',
  },
  value: {
    fontWeight: 500,
    textTransform: 'uppercase',
    marginLeft: 5,
  },
  titleProcedures: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: '10px 0px',
    fontSize: 13,
    textTransform: 'uppercase',
  },
  tableContainer: {
    borderWidth: 2,
    borderRadius: 6,
  },
  rowHeader: {
    width: '98%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '3px',
    borderBottomWidth: 1,
  },
  columnHeader: {
    flex: 1,
    fontSize: 11,
    margin: 1,
    fontWeight: 'bold',
  },
  rowBody: {
    width: '98%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '3px',
    borderBottomWidth: 1,
  },
  columnBody: {
    flex: 1,
    fontSize: 10,
    margin: 1,
  },
  containerTotalView: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 8,
    borderWidth: 2,
    borderRadius: 6,
    marginTop: 10,
  },
  containerRow: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 12,
  },
  totalText: {
    textTransform: 'uppercase',
  },
  validationCodeContainer: {
    marginTop: 10,
    alignItems: 'center',
  },
  validationCodeText: {
    fontSize: 10,
    textTransform: 'uppercase',
  },
});
